import {add, Identify, identify, init, setOptOut, setUserId, track} from '@amplitude/analytics-browser';

import AMPLITUDE_EVENT_PROPERTIES from '../../consts/amplitude/amplitudeEventProperties';
import AMPLITUDE_USER_PROPERTIES from '../../consts/amplitude/amplitudeUserProperties';
import {
    makeSelectAmplitudeModelName,
    selectDeviceSerialNumber,
    selectHolderSerialNumber,
    selectIotHolderType,
    selectIsHolderConnected,
} from '../../state/selectors/iotDevice';
import {getState} from '../../state/store';
import cryptoService from '../cryptoService';
import EnricherPlugin from './plugins/EnricherPlugin';

const initAmplitude = () => {
    add(new EnricherPlugin());
    init(process.env.REACT_APP_AMPLITUDE_API_KEY, undefined, {
        serverZone: 'EU',
        appVersion: process.env.REACT_APP_VERSION,
        // Disable tracking while market config is not initialized
        optOut: true,
    });
};

const setAmplitudeUserId = (userId) => {
    setUserId(userId);
};

const setIqosDeviceId = (deviceId) => {
    const identifyObj = new Identify();

    identifyObj.postInsert(AMPLITUDE_USER_PROPERTIES.IQOS_DEVICES_IDS, deviceId);

    identify(identifyObj);
};

const setIqosModelName = (modelName) => {
    const identifyObj = new Identify();

    identifyObj.postInsert(AMPLITUDE_USER_PROPERTIES.IQOS_DEVICES_MODELS, modelName);

    identify(identifyObj);
};

const setMarket = (marketName) => {
    const identifyObj = new Identify();

    identifyObj.set(AMPLITUDE_USER_PROPERTIES.MARKET, marketName);

    identify(identifyObj);
};

const enableAmplitude = (isEnabled) => {
    setOptOut(!isEnabled);
};

const trackEvent = ({eventType, serialNumber, deviceType, properties}) => {
    const modelName = makeSelectAmplitudeModelName(deviceType)(getState());

    track(eventType, {
        [AMPLITUDE_EVENT_PROPERTIES.IQOS_PRODUCT_MODEL_TYPE]: modelName,
        [AMPLITUDE_EVENT_PROPERTIES.IQOS_PRODUCT_DEVICE_ID]: cryptoService.hashMD5(serialNumber),
        ...properties,
    });
};

const trackDeviceEvent = (eventType, properties) => {
    const serialNumber = selectDeviceSerialNumber(getState());

    trackEvent({eventType, serialNumber, properties});
};

const trackHolderEvent = (eventType, properties) => {
    const deviceType = selectIotHolderType(getState());
    const serialNumber = selectHolderSerialNumber(getState());

    trackEvent({eventType, deviceType, serialNumber, properties});
};

const trackProductEvent = ({isHolder, eventType, properties}) => {
    const method = isHolder ? trackHolderEvent : trackDeviceEvent;

    method(eventType, properties);
};

const trackDeviceAndHolderEvent = (eventType, properties) => {
    const isHolderConnected = selectIsHolderConnected(getState());

    trackDeviceEvent(eventType, properties);

    if (isHolderConnected) {
        trackHolderEvent(eventType, properties);
    }
};

export default {
    initAmplitude,
    setAmplitudeUserId,
    setIqosDeviceId,
    setMarket,
    setIqosModelName,
    enableAmplitude,
    trackEvent,
    trackProductEvent,
    trackHolderEvent,
    trackDeviceEvent,
    trackDeviceAndHolderEvent,
};
